<script setup lang="ts">
import { onMounted, ref } from 'vue'

import { api } from '@/lib/api'
import { loadGsi } from '@/lib/google'

const emit = defineEmits<{ signedIn: [] }>()
const button = ref<HTMLDivElement>()
const error = ref('')

onMounted(async () => {
  const { googleClientId } = await api<{ googleClientId: string }>('/config')
  if (!googleClientId) { error.value = 'Google sign-in is not configured (GOOGLE_CLIENT_IDS).'; return }
  await loadGsi()
  window.google!.accounts.id.initialize({
    client_id: googleClientId, hd: 'inventia.life',
    callback: async ({ credential }) => {
      try {
        await api('/auth/google', { method: 'POST', body: JSON.stringify({ idToken: credential }) })
        emit('signedIn')
      } catch (e) {
        error.value = (e as Error).message
      }
    },
  })
  window.google!.accounts.id.renderButton(button.value!, { theme: 'outline', size: 'large', text: 'signin_with' })
})
</script>

<template>
  <div class="min-h-screen flex items-center justify-center">
    <div class="card text-center p-8 max-w-sm">
      <div class="font-bold text-brand text-lg mb-1">Outreach Insights</div>
      <p class="text-muted mb-5">Sign in with your Inventia Google account.</p>
      <div ref="button" class="flex justify-center" />
      <p v-if="error" class="text-warn mt-4">{{ error }}</p>
    </div>
  </div>
</template>
